import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/cashier',
    name: 'Cashier',
    component: () => import('@/views/Cashier.vue'),
    meta: { title: '收银台' }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/pages',
    children: [
      {
        path: 'pages',
        name: 'Pages',
        component: () => import('@/views/Pages.vue'),
        meta: { title: '页面管理' }
      },
      {
        path: 'editor/:id',
        name: 'Editor',
        component: () => import('@/views/Editor.vue'),
        meta: { title: '页面编辑' }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/views/Products.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'images',
        name: 'Images',
        component: () => import('@/views/ImageSpace.vue'),
        meta: { title: '图片空间', requiresAuth: true }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/Users.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'customers',
        name: 'Customers',
        component: () => import('@/views/Customers.vue'),
        meta: { title: '客户管理' }
      },
      {
        path: 'roles',
        name: 'Roles',
        component: () => import('@/views/Roles.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'categories',
        name: 'Categories',
        component: () => import('@/views/Categories.vue'),
        meta: { title: '商品分类' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/Settings.vue')
      },
      {
        path: 'staffs',
        name: 'Staffs',
        component: () => import('@/views/Staffs.vue'),
        meta: { title: '员工管理' }
      },
      {
        path: 'tables',
        name: 'Tables',
        component: () => import('@/views/Tables.vue'),
        meta: { title: '桌号管理' }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/Orders.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/Finance.vue'),
        meta: { title: '财务概览' }
      },
      {
        path: 'distributors',
        name: 'Distributors',
        component: () => import('@/views/Distributors.vue'),
        meta: { title: '分销管理' }
      },
      {
        path: 'commissions',
        name: 'Commissions',
        component: () => import('@/views/Commissions.vue'),
        meta: { title: '佣金记录' }
      },
      {
        path: 'withdrawals',
        name: 'Withdrawals',
        component: () => import('@/views/Withdrawals.vue'),
        meta: { title: '提现管理' }
      },
      {
        path: 'coupons',
        name: 'coupons',
        component: () => import('@/views/Coupons.vue'),
        meta: { title: '优惠券' }
      },
      {
        path: 'seckills',
        name: 'seckills',
        component: () => import('@/views/Seckills.vue'),
        meta: { title: '秒杀活动' }
      },
      {
        path: 'buygets',
        name: 'buygets',
        component: () => import('@/views/BuyGets.vue'),
        meta: { title: '买送活动' }
      },
      {
        path: 'rushbuys',
        name: 'rushbuys',
        component: () => import('@/views/RushBuys.vue'),
        meta: { title: '抢购活动' }
      },
      {
        path: 'products/create',
        name: 'ProductCreate',
        component: () => import('@/views/ProductForm.vue'),
        meta: { title: '新增商品' }
      },
      {
        path: 'products/:id/edit',
        name: 'ProductEdit',
        component: () => import('@/views/ProductForm.vue'),
        meta: { title: '编辑商品' }
      },
      {
        path: 'tenants',
        name: 'Tenants',
        component: () => import('@/views/Tenants.vue'),
        meta: { title: '租户管理' }
      },
      {
        path: 'platform-orders',
        name: 'PlatformOrders',
        component: () => import('@/views/PlatformOrders.vue'),
        meta: { title: '全平台订单' }
      },
      {
        path: 'platform-finance',
        name: 'PlatformFinance',
        component: () => import('@/views/PlatformFinance.vue'),
        meta: { title: '全平台财务' }
      },
      {
        path: 'platform-customers',
        name: 'PlatformCustomers',
        component: () => import('@/views/PlatformCustomers.vue'),
        meta: { title: '全平台客户' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：token 认证 + 超管/租户菜单隔离
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path === '/login') {
    next()
    return
  }
  if (to.path === '/cashier') {
    if (!token) { next('/login'); return }
    next()
    return
  }
  if (!token) {
    next('/login')
    return
  }

  const user = JSON.parse(localStorage.getItem('admin_user') || 'null')
  const isPlatform = user && user.role === 'platform'
  const platformRoutes = ['/tenants', '/platform-orders', '/platform-finance', '/platform-customers']
  const isPlatformRoute = platformRoutes.includes(to.path)

  if (isPlatform && !isPlatformRoute) {
    // 超管只能访问平台路由
    next('/tenants')
    return
  }
  if (!isPlatform && isPlatformRoute) {
    // 租户用户不能访问平台路由
    next('/pages')
    return
  }

  next()
})

export default router
